import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { claimTypeOptions } from './constants'

const ClaimTypeSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <ComboBox
      value={value || []}
      label={t('Tipo de incidencia')}
      fullWidth
      multiple
      handleChange={handleChange}
      menuItems={claimTypeOptions.map(option => ({ label: t(option.label), value: option.value }))}
      placeholder={t('Todos')}
    />
  )
}

export default ClaimTypeSelector
